var _style, _g, _defs, _defs2, _polyline, _polyline2, _defs3, _polyline3, _path, _path2, _path3, _path4, _path5, _line, _line2, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920.1 357.1",
    style: {
      enableBackground: "new 0 0 1920.1 357.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#93D500;}\n\t.st1{fill:none;stroke:#231F20;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{clip-path:url(#SVGID_2_);}\n\t.st3{clip-path:url(#SVGID_4_);fill:none;stroke:#231F20;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{clip-path:url(#SVGID_2_);fill:#00B9F1;}\n\t.st5{clip-path:url(#SVGID_6_);fill:none;stroke:#231F20;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{clip-path:url(#SVGID_6_);fill:#00B9F1;}\n\t.st7{clip-path:url(#SVGID_6_);fill:#FFDD00;}\n\t.st8{clip-path:url(#SVGID_6_);fill:none;stroke:#231F20;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1886.5,104.1c-42.7-25.9-103.7-56.5-153.7-66.9c-28.9-6-58.4-8.7-87.8-8.5c-65.7-0.2-146.4,24.8-218,75.4 c-40.8-25.9-99.1-56.5-146.8-66.9c-23.3-5.1-46.9-7.8-70.6-8.4v0c-0.4,0-0.8,0-1.2,0c-1.6,0-3.2-0.1-4.7-0.1c-0.3,0-0.5,0-0.8,0 c-1.3,0-2.5,0-3.8,0c-30.6,0-61.2,2.7-91.3,8.5c-53.6,10.4-119.1,41-165,66.9v253.2h977.4V83.4 C1908.8,89.8,1897.5,96.7,1886.5,104.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M946.3,104.1c-42.7-25.9-103.7-56.5-153.7-66.9c-28.9-6-58.4-8.7-87.8-8.5c-65.7-0.2-146.4,24.8-218,75.4 c-40.8-25.9-99.1-56.5-146.8-66.9c-23.3-5.1-46.9-7.8-70.6-8.4v0c-0.4,0-0.8,0-1.2,0c-1.6,0-3.2-0.1-4.7-0.1c-0.3,0-0.5,0-0.8,0 c-1.3,0-2.5,0-3.8,0c-30.6,0-61.2,2.7-91.3,8.5c-53.6,10.4-119.1,41-165,66.9v253.2H980V83.4C968.6,89.8,957.4,96.7,946.3,104.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1920.1,83.4c-11.4,6.3-22.6,13.2-33.7,20.7c-42.7-25.9-103.7-56.5-153.6-66.9c-28.9-6-58.4-8.7-87.8-8.5 c-65.7-0.2-146.4,24.8-218,75.4c-40.8-25.9-99.1-56.5-146.8-66.9c-23.3-5.1-46.9-7.8-70.6-8.4v0c-0.4,0-0.8,0-1.2,0 c-1.6,0-3.2-0.1-4.7-0.1c-0.3,0-0.5,0-0.8,0c-1.3,0-2.5,0-3.8,0c-30.6,0-61.2,2.7-91.3,8.5c-53.6,10.4-119.1,41-165,66.9 c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M943.4,104c-42.7-25.9-103.7-56.5-153.6-66.9c-28.9-6-58.4-8.7-87.8-8.5c-65.7-0.2-146.4,24.8-218,75.4 c-40.8-25.9-99.1-56.5-146.8-66.9c-23.3-5.1-46.9-7.8-70.6-8.4v0c-0.4,0-0.8,0-1.2,0c-1.6,0-3.2-0.1-4.7-0.1c-0.3,0-0.5,0-0.8,0 c-1.3,0-2.5,0-3.8,0c-30.6,0-61.2,2.7-91.3,8.5C111,47.5,45.5,78.1-0.3,104c0,0,0,0,0,0"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 676.1,
    y: -0.2,
    width: 41,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 676.1,
    y: -0.2,
    width: 41,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "715.6,8 711.6,7.7 714.2,4.6  "
  }))), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "688,14.9 679.8,3.5 682.5,1.8 685.1,3.5 684.3,0.9 688.4,0.5 693,10.7  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 676.1,
    y: -0.2,
    width: 41,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "688,14.9 679.8,3.5 682.5,1.8 685.1,3.5 684.3,0.9 688.4,0.5 693,10.7  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M696.5,10.2c1-2.3,2-4.5,3.8-6.3c2.6-2.6,6.8-2.9,9.4-0.4c4.8,4.6,4.3,12.5-0.7,16.9 c-2.9,2.7-7.1,3.6-10.9,3.1c-3.5-0.5-5.8-2.6-7.7-5.5c-0.9-1.4-2-3.1-2.2-4.8c-0.2-1.6,0.8-2.5,2.2-2.9c1.5-0.5,3.1-0.5,4.7-0.5 c0.3,0,1.1,0.1,1.3-0.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M696.5,10.2c1-2.3,2-4.5,3.8-6.3c2.6-2.6,6.8-2.9,9.4-0.4c4.8,4.6,4.3,12.5-0.7,16.9 c-2.9,2.7-7.1,3.6-10.9,3.1c-3.5-0.5-5.8-2.6-7.7-5.5c-0.9-1.4-2-3.1-2.2-4.8c-0.2-1.6,0.8-2.5,2.2-2.9c1.5-0.5,3.1-0.5,4.7-0.5 c0.3,0,1.1,0.1,1.3-0.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M711.8,16.9c-0.7-0.4-1.4-0.8-2.1-1.1c-5.9-2.3-12.2-0.2-14.2,4.8c-0.2,0.6-0.4,1.2-0.5,1.9 c1,0.5,2,0.9,3.3,1.1c3.8,0.5,8-0.5,10.9-3.1C710.2,19.4,711.1,18.2,711.8,16.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M711.8,16.9c-0.7-0.4-1.4-0.8-2.1-1.1c-5.9-2.3-12.2-0.2-14.2,4.8c-0.2,0.6-0.4,1.2-0.5,1.9 c1,0.5,2,0.9,3.3,1.1c3.8,0.5,8-0.5,10.9-3.1C710.2,19.4,711.1,18.2,711.8,16.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M706.5,6.7c0,0,0.6,1.4,1.7,1.2c1.2-0.1,0.8-1.7,0.8-1.7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 696.9,
    y1: 23.5,
    x2: 697.7,
    y2: 27.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 702.7,
    y1: 23.5,
    x2: 704,
    y2: 27.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M677,15.4c2.5,1.2,5.1,2.5,7.7,3.4c4.1,1.6,9.3,3.2,13.7,2.1c4.2-1.1,7-5.9,4.7-9.9c-3-5.1-9.9-2.5-13.6,0 c-2,1.2-3.9,2.5-6.1,3C681.5,14.6,677,15.4,677,15.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M677,15.4c2.5,1.2,5.1,2.5,7.7,3.4c4.1,1.6,9.3,3.2,13.7,2.1c4.2-1.1,7-5.9,4.7-9.9c-3-5.1-9.9-2.5-13.6,0 c-2,1.2-3.9,2.5-6.1,3C681.5,14.6,677,15.4,677,15.4z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrass);
export default __webpack_public_path__ + "static/media/grass.d9435a1533b69757df273fe53afc6726.svg";
export { ForwardRef as ReactComponent };